import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowCornerUpRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowCornerUpRight"><Path fillRule="evenodd" clipRule="evenodd" d="M4.5 20.3107V9.81066H18.4393L15.1893 13.0607L16.25 14.1213L21.3107 9.06066L16.25 4L15.1893 5.06066L18.4393 8.31066H3V20.3107H4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowCornerUpRight;
